<template>
  <InternalLayout>
    <header class="assessment-header">
      <StepIndicator :steps="2" :currentStep="2" @stepClick="onStepClick" />
      <SmallHeader tag="h1">Hospital Report</SmallHeader>
    </header>
    <AssessmentForm @submit="onSubmit" v-if="hospitalData">
      <template slot="header">
        <div class="hospital-name">{{ hospitalData.hospital.name }}</div>
        <div>Hospital’s capacity to accept COVID-19 patients is:</div>
      </template>

      <RadioInput
        :value="status"
        :options="[
          'Healthy Capacity',
          'Limited Capacity',
          'Borderline No Capacity',
          'No Capacity',
        ]"
        @change="onChange"
      />
    </AssessmentForm>
  </InternalLayout>
</template>

<script>
import Api from '@/store/api';
import AssessmentForm from '@/components/assessment-form';
import InternalLayout from '@/components/internal-layout';
import RadioInput from '@/components/radio-input';
import SmallHeader from '@/components/small-header';
import StepIndicator from '@/components/step-indicator';
import { CapacityType, ReporterType } from '@/store/types';
import { RouterAliases } from '@/router';
import { StoreGetters, loadHospitalDetails } from '@/store';
import { mapGetters } from 'vuex';

export default {
  components: {
    AssessmentForm,
    InternalLayout,
    RadioInput,
    SmallHeader,
    StepIndicator,
  },
  props: {
    hospitalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      status: 0,
    };
  },
  computed: {
    ...mapGetters({ getHospital: StoreGetters.GET_HOSPITAL_DETAILS_BY_ID }),
    hospitalData() {
      return this.getHospital(this.hospitalId);
    },
  },
  created() {
    if (!this.hospitalId) {
      this.$router.replace({
        name: RouterAliases.HOSPITAL_SEARCH,
      });
      return;
    }
    loadHospitalDetails(this.hospitalId);
  },
  methods: {
    onChange(val) {
      this.status = parseInt(val, 10);
    },
    async onSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      const report = {
        hospital_id: this.hospitalId,
        filed_at: Math.round(new Date().getTime() / 1000),
        reporter_type: ReporterType.UNSPECIFIED,
        capacity_type: Object.values(CapacityType)[this.status + 1],
      };
      const { report_id: reportId } = await Api.submitSimpleReport(report);
      this.$router.push({
        name: RouterAliases.REPORT_CONFIRMATION,
        query: {
          report: reportId,
        },
      });
      this.isLoading = false;
    },
    onStepClick(step) {
      if (step === 1) {
        this.$router.push({
          name: RouterAliases.HOSPITAL_DETAILS,
          params: {
            hospitalId: this.hospitalId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.assessment-form {
  margin-top: 54px;
}

.hospital-name {
  color: var(--white-transparent);
  font-size: 18px;
  font-weight: 500;
}
</style>
